import * as React from 'react';
import { Dispatch } from 'react-redux';
import { StoreState } from '../../../../reducers';
import Utils from '../../../../utils';
import RoutesUtils from '../../../../utils/routes';
import { Logo } from './styles';
import Tooltip from '../../../../components/Tooltip';
import UserAgentUtils from '../../../../utils/userAgent';
import { GalleryInfosActionKeys } from '../../../../containers/Gallery/actions';
import { MenuActionKeys } from '../../../../containers/MenuManager/actions';

interface HeaderLogoProps {
	dispatch: Dispatch<StoreState>;
	brandLogoUrl: string;
	brandUrl: string;
	isCurrentPageHome: boolean;
	isDisabled?: boolean;
	icon?: string;
	label?: string;
}

class HeaderLogo extends React.Component<HeaderLogoProps, {}> {
	constructor(props: HeaderLogoProps) {
		super(props);
		this.handleClick = this.handleClick.bind(this);
	}

	handleClick = (): void => {
		const { isDisabled, brandUrl, isCurrentPageHome, dispatch } = this.props;

		if (isDisabled) {
			return;
		}

		if (brandUrl) {
			window.open(brandUrl);
		} else {
			if (isCurrentPageHome) {
				dispatch({ type: GalleryInfosActionKeys.FORCE_VIEW_UPDATE });
				dispatch({ type: MenuActionKeys.REQUEST_CLOSE_LEFT_MENU });
			} else {
				window.location.hash = `#${RoutesUtils.getPathHome()}`;
			}
		}
	}

	render() {
		const { brandLogoUrl, brandUrl, isDisabled } = this.props;
		const tooltipId = Utils.generateId();

		return (
			<Logo
				data-tip={true}
				data-for={tooltipId}
				isSvg={Utils.getFileExtension(brandLogoUrl) === 'svg'}
				isDisabled={isDisabled}
			>
				{brandLogoUrl &&
					<img src={brandLogoUrl} onClick={this.handleClick} />
				}
				{(UserAgentUtils.isDesktop() && brandUrl) &&
					<Tooltip id={tooltipId} text={brandUrl} isCustom={true} />
				}
			</Logo>
		);
	}
}

export default HeaderLogo;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/MenuManager/Header/Logo/index.tsx